import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import messages from '../../utils/translationMessages';
import PropTypes from 'prop-types';
import './styles.css';

class ViewCarousel360Images extends PureComponent {
  render() {
    const {
      intl: { formatMessage }
    } = this.props;
    return (
      <div
        className="view-360Images"
        onClick={() => {
          this.props.listingHasImages
            ? this.props.openCarouselModal(this.props.listingNumVideos + 1)
            : this.props.openCarouselModal(this.props.listingNumVideos);
        }}
      >
        {formatMessage(messages.viewCarousel360Images.image360)}
      </div>
    );
  }
}

ViewCarousel360Images.propTypes = {
  images: PropTypes.array,
  openCarouselModal: PropTypes.func,
  listingNumVideos: PropTypes.number,
  listingHasImages: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

export default injectIntl(ViewCarousel360Images);
